import Typography from '@mui/material/Typography';
import { renderTextOrNonValue } from '../../helper';
import { IProps } from './model';

export const RenderTextOrLink = ({ useLink, text, link, Link }: IProps) => {
  if (useLink && text && link) {
    return (
      <Link href={link} prefetch={false} passHref legacyBehavior aria-label={text}>
        <Typography
          title={text}
          component="a"
          data-testid="text-link"
          sx={{ textDecoration: 'underline' }}
        >
          {text}
        </Typography>
      </Link>
    );
  }

  return (
    <Typography component="p" data-testid="text">
      {renderTextOrNonValue(text)}
    </Typography>
  );
};
